
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './projects.css';
import img01 from '../../images/newProjects/4.png';
import img02 from '../../images/newProjects/2.png';
import img03 from '../../images/newProjects/1.png';
import ProjectsCard from './projectsCard/ProjectsCard';

const projectsData = [
    {
        imgUrl: img01,
        title: 'Restaurant Website',
        url: 'https://swiliresto.netlify.app/',
    },
    {
        imgUrl: img02,
        title: 'Take a Trip',
        url: 'https://marsh22.netlify.app',
    },
    {
        imgUrl: img03,
        title: 'First Travel',
        url: 'https://barnasawa.netlify.app',
    },
]

const Projects = () => {
  return (
    <section id="projects">
        <Container>
            <Row>
                <Col lg='12' className='projects-top mb-5'>
                    <h2>Projects</h2>
                    <h6>Explore my projects by hover on it or You can click one of the project below and start navigate into it.</h6>
                </Col>

                {
                    projectsData.map((item, index)=>(
                        <ProjectItem
                            key={index}
                            imgUrl={item.imgUrl}
                            title={item.title}
                            url={item.url}
                        />
                    ))
                }
                
            </Row>
        </Container>
    </section>
  )
}


const ProjectItem = ({imgUrl, title, url}) => {
    return <Col lg='4' md='6' sm='6'>
                <div className='p_list'>
                    <ProjectsCard imgUrl={imgUrl} title={title} url={url}/>
                </div>
            </Col>
};

export default Projects;